import { GameLiveConnection } from '../../core/classes/gameLiveConnection';
import { DefaultQueryParams } from '../../core/constants/defaultQueryParams';
import { gameService } from '../gameService';
import { environmentBuilder } from '../../core/helpers/environmentBuilder';
import { parseQuery } from '../../core/helpers/parseQuery';
import { jackpotService } from '../jackpotService';

export class JackpotConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  async sendGameGetInitialState(isFirst = true) {
    if (isFirst) {
      this.executeConnections();
    }
    await this.sendInitial();
  }

  async sendInitial() {
    const {
      [DefaultQueryParams.PartnerId]: partnerId,
      [DefaultQueryParams.GameId]: gameId,
      [DefaultQueryParams.Currency]: Currency,
    } = parseQuery(window.location.search);
    await super.sendJackpotInitial(partnerId, gameId, Currency);
    await super.sendJackpotWinnerInfo(partnerId);
  }

  executeConnections() {
    super.onJackpotWin(jackpotService.handleJackpotWin.bind(gameService));
    super.onJackpotUpdate(jackpotService.handleJackpotResult.bind(gameService));
    super.onJackpotWinnerInfoResult(jackpotService.handleJackpotWinnerInfoResult.bind(gameService));
    super.onBoostedJackpotExpirationInfoResult(
      gameService.handleBoostedJackpotExpirationInfoResult.bind(gameService)
    );
    super.onBoostedJackpotWinnerInfoResult(
      jackpotService.handleBoostedJackpotWinnerInfoResult.bind(gameService)
    );
    super.onBoostedJackpotActivationInfoResult(
      gameService.handleBoostedJackpotActivationInfoResult.bind(gameService)
    );
    super.onClose();
    super.onReconnected(jackpotService.handleReconnected.bind(gameService));
    super.onReconnecting();
  }
}

const { socketUrlJackpot } = environmentBuilder();

const url = () => ({ url: `${socketUrlJackpot}` });
export const jackpotConnection = new JackpotConnection(url());
